<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Horários' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido"></div>
  <div>
    <ion-card-content *ngIf="horarioList.length > 0">
      <ion-list *ngFor="let horario of horarioList">
        <ion-item (click)="selecionarHorario(horario)">
          <ion-label>
            <ion-row class="content-row one-line">
              <ion-col size="auto">
                <div class="square-icon">
                  <i class="fas fa-clock icon-list"></i>
                </div>
              </ion-col>

              <ion-col class="item-content">
                <h3 class="item-title bold-2">{{getDiaSemana(horario.diaSemana)}}</h3>

                <div class="item-description">
                  <p class="horario" *ngIf="horario.horarioInicio">{{'Das' | translate}}
                    {{getHorario(horario.horarioInicio)}} {{'até' | translate}} {{getHorario(horario.horarioFim)}}
                    {{horario.frequenciaDias == 7 ? ('semanalmente' | translate) :
                    horario.frequenciaDias == 14 ? ('a cada duas semanas' | translate) :
                    horario.frequenciaDias == 30 ? ('mensalmente' | translate) :
                    ''
                    }}</p>
                </div>
              </ion-col>

              <ion-col size="auto">
                <ion-icon name="ellipsis-vertical" class="icon-list"></ion-icon>
              </ion-col>
            </ion-row>
          </ion-label>
        </ion-item>
      </ion-list>
    </ion-card-content>

    <ion-grid>
      <ion-row class="ion-justify-content-center">
        <ion-col size="7">
          <div>
            <ion-button
              class="btn-default"
              expand="block"
              (click)="addHorario();"
            >
              {{'Novo Horário' | translate}}
            </ion-button>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-list *ngIf="horarioList.length == 0" class="img-not-found">
      <sem-registro></sem-registro>
    </ion-list>
  </div>
</ion-content>